<div class="bubble-wrapper" [ngClass]="{ center: center, 'full-width': !center }">
  <div
    [ngClass]="{
      'bg-blue-600': project?.project_status?.key === PROJECT_STATUS_KEY.IN_PROGRESS,
      'bg-green-400': project?.project_status?.key === PROJECT_STATUS_KEY.COMPLETED,
      'bg-straw': project?.project_status?.key === PROJECT_STATUS_KEY.PLANNED,
      'bg-purple-700': project?.project_status?.key === PROJECT_STATUS_KEY.CANCELED,
      'bg-tinted-grey': project?.project_status?.key === PROJECT_STATUS_KEY.ARCHIVED,
      'bg-yellow-500': project?.project_status?.key === PROJECT_STATUS_KEY.BIDDING,
      'bg-green-600': project?.project_status?.key === PROJECT_STATUS_KEY.AWARDED,
      'bg-red-200': project?.project_status?.key === PROJECT_STATUS_KEY.ON_HOLD,
      'bg-color_cancel':
        project?.project_status?.key === PROJECT_STATUS_KEY.CANCELED ||
        project?.project_status?.key === PROJECT_STATUS_KEY.DELETED
    }"
    class="round-mark"
  ></div>
  @if (!isDropDown && selectedStatus) {
    <span class="project-status">
      {{ selectedStatus?.name }}
    </span>
  }
  @if (!selectedStatus) {
    <span class="project?-status">-</span>
  }

  @if (isDropDown && selectedStatus) {
    <div class="mat-form-field-container">
      <mat-form-field subscriptSizing="dynamic" class="borderless">
        <mat-select [value]="selectedStatus.id" (valueChange)="changeProjectStatus($event)">
          @for (status of availableStatuses; track status) {
            <mat-option [value]="status.id">
              <div class="general-selection-text">{{ status.name | titlecase }}</div>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
</div>
